class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    const { isCombinedProduct, targetUrl } = this.combinedListingCheck(e);

    this.toggleAddButton(true, '', false);

    if (isCombinedProduct) {
      this.fetchProductSection(targetUrl);
      return;  // Stop execution if false
    }

    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateCertificationRequirement();
    }

    const event = new CustomEvent('ajaxProduct:variantUpdated', {
      detail: {
        variant: this.currentVariant
      }
    });
    document.dispatchEvent(event);
  }

  combinedListingCheck(e) {
    const currentUrl = window.location.pathname;
    const targetUrl = e.target.dataset.productUrl;
    let isCombinedProduct = false;

    if (targetUrl != undefined && currentUrl != targetUrl) {
      isCombinedProduct = true;
    }

    return { isCombinedProduct, targetUrl };
  }

  async fetchProductSection(newProductUrl) {
    const productElement = this.closest('.main-product');
    const productSectionId = this.dataset.section;
    let params = `section_id=${productSectionId}&`;

    const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
      params += `option_values=${selectedOptionValues}`;

    fetch(`${newProductUrl}?${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        productElement.innerHTML = html.querySelector('.main-product').innerHTML;
        window.history.replaceState({ }, '', `${newProductUrl}`);
      });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    
    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }
    
    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${this.currentVariant.featured_media.id}`)
    }

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const isGrid = mediaGridySlider.dataset.desktopEnabled === 'false' ? true : false;
    if (isDesktop && isGrid) {
      document.getElementById(`item-${this.currentVariant.featured_media.id}`)?.scrollIntoView();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateCertificationRequirement() {
    if (!this.currentVariant) return;
    
    // Check if current variant requires certification (check both possible metafield names)
    const variantData = window.productVariants?.find(v => v.id === this.currentVariant.id);
    const requiresCertification = variantData?.metafields?.custom?.certified_customers_only === true || 
                                   variantData?.metafields?.custom?.certified_customers === true;
    const isCertifiedCustomer = window.isCertifiedCustomer === true;
    
    // Get the product container
    const productContainer = document.getElementById(this.dataset.section);
    
    // Toggle cert-pending class on the main product container
    if (requiresCertification && !isCertifiedCustomer) {
      productContainer?.classList.add('cert-pending');
    } else {
      productContainer?.classList.remove('cert-pending');
    }
    
    // Update the data attribute on product forms
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      if (requiresCertification) {
        productForm.setAttribute('data-requires-certification', 'true');
      } else {
        productForm.setAttribute('data-requires-certification', 'false');
      }
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
      this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        const packSizeSource = html.getElementById(
          `PackSize-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const packSizeDestination = document.getElementById(`PackSize-${this.dataset.section}`);

        if (packSizeSource && packSizeDestination) {  
          packSizeDestination.innerHTML = packSizeSource.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: this.currentVariant
          }
        }));
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll('.btn--add-multiplier');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.removeAttribute('disabled');
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (disable) {
        addButton_BuyBar.setAttribute("disabled", "disabled");
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        if (this.dataset.isPreorder == "true") {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (!button_BuyBar) return;
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);

// GROUPING ELEMENT
class VariantItems extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  async init() {
    this.cartItemsJSON = JSON.parse(this.querySelector('.ajax-cart').innerHTML)?.items;
    //this.addEventListener('variantItemQuantityChange', this.updateCart.bind(this));
  }

  setLoadingState(isLoading, silently = false) {
    this.isLoading = isLoading;
    this.setAttribute('data-is-loading', isLoading);
    if (silently === false) {
      this.classList.toggle('is-loading', isLoading);
    }
  }

  async fetchLiveProduct(variantId) {
    /**
     * Build URL for displaying selected variant
     * window.routes.root = '/' or '/en/'
     * @type {URL}
     * @example https://www.example.com/products/product-handle?variant=456
     */

    const url = new URL(window.top.location.origin + window.routes.root + '/products/' + this.dataset.productHandle);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('view', 'ajax-variant-items');

    // Fetch fresh HTML for the product
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/html',
      }
    });
    const html = await response.text();

    // Parse the HTML into a DOM
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    return doc;
  }

  /**
   * Update the cart
   * - Add or update the current variant
   *
  */
  async updateCart(event) {
    const { variantId, quantity } = event.detail;
    
    this.setLoadingState(true, true);
    

    console.log(this.cartItemsJSON)

    const updateMethod = this.cartItemsJSON && this.cartItemsJSON.find((item) => item.variant_id === variantId) ? 'update' : 'add';
    console.log('update cart', updateMethod, variantId, quantity)

    if (updateMethod === 'add' && quantity === 0) {
      return;
    }

    
    try {
      const response = await this.updateCartPromise(updateMethod, variantId, quantity);
      const json = await response.json();

      if (!response.ok) throw new Error(json.description);

      // now find the freshly added item in the cart
      // and add it to the cartItemsJSON array
      if (updateMethod === 'add') {
        // if updateMethod is 'add'
        // then the item is the last item in the cart
        const the_item = json.items[json.items.length - 1];
        if (!this.cartItemsJSON) this.cartItemsJSON = [];
        this.cartItemsJSON.push(the_item);
      } else {
        // if updateMethod is 'update'
        // find the item in the cartItemsJSON array
        // and update the quantity
        if (quantity === 0) {
          // remove item from cartItemsJSON
          this.cartItemsJSON = this.cartItemsJSON.filter((item) => item.variant_id !== variantId);
        } else {
          const thisCartItem = this.cartItemsJSON.find((item) => item.variant_id === variantId);
          thisCartItem.quantity = quantity;
        }
      }

      console.log('\nDONE!', this.cartItemsJSON)

      // trigger custom event 'ajaxProduct:added' to update cart drawer
      this.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: {
          silently: true
        }
      }));

      // update notification bar
      const doc = await this.fetchLiveProduct();
      const notificationBar = doc.querySelector('.ajax-notification .cart_item--notification');
      const _notificationBar = this.querySelector('.ajax-notification .cart_item--notification');
      const thisProductInCart = this.cartItemsJSON.find((item) => item.handle === this.dataset.productHandle);

      if (updateMethod === 'add') {
        _notificationBar.classList.add('show');
        _notificationBar.innerHTML = notificationBar.innerHTML;
      } else if (updateMethod === 'update' && quantity === 0 && !thisProductInCart) {
        _notificationBar.classList.remove('show');
        _notificationBar.innerHTML = '';
      } else {
        _notificationBar.innerHTML = notificationBar.innerHTML;
      }

    } catch (error) {
      alert(error);
      console.error(error);
    }

    this.setLoadingState(false, true);
  }

  async updateCartPromise(updateMethod, variantId, quantity) {

    if (updateMethod === 'add' && quantity === 0) {
      // return empty json 
      return new Promise((resolve, reject) => {
        resolve({
          json: () => {
            return {
              items: []
            }
          }
        })
      });
    } else if (updateMethod === 'update') {      
      // remove item from cart
      return new Promise(async (resolve, reject) => {
        const thisCartItem = this.cartItemsJSON.find((item) => item.variant_id === variantId);
        const line_key = thisCartItem.key;

        const response = await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: line_key,
            quantity: quantity
          }),
        });
        resolve(response);
      })
    } else if (updateMethod === 'add' && quantity > 0) {
      // add item to cart
      return new Promise(async (resolve, reject) => {
        const response = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: quantity,
              },
            ],
          }),
        });
        resolve(response);
      })
    }
  }
}

customElements.define('variant-items', VariantItems);

// SINGLE VARIANT ITEM
class VariantItem extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  async init() {
    this.initQuantityInputs();
  }

  initQuantityInputs() {
    this.quantityRules = JSON.parse(this.querySelector('[data-increment]').dataset.increment);

    // Initialize quantity change event. 
    this.quantityInputs = this.querySelectorAll("input[type=number]");
    this.quantityInputs.forEach((input) => {
      input.addEventListener("change", this.changeQuantity.bind(this));
    });

    // Initialize quantity buttons
    this.quantityButtons = this.querySelectorAll(".quantity__button");
    this.quantityButtons.forEach((button) => {
      button.addEventListener("click", this.changeQuantity.bind(this));
    });
  }

  changeQuantity(event) {    
    // Identify if called by click or change event
    const isClick = event.type === 'click';
    const quantityInput = this.querySelector('input[type=number]');
    const upsellQuantityInput = document.querySelector('.upsell-bundle');
    //console.log("upsellQuantityInput", upsellQuantityInput.value)
    
    // If click, and button name is "minus" then decrease quantity
    if (isClick && event.target.name === 'minus') {
      // Click - minus button
      quantityInput.value = parseInt(quantityInput.value) - this.quantityRules.increment;
      if (upsellQuantityInput != null){
        if (upsellQuantityInput.value > 0){
          upsellQuantityInput.value = parseInt(upsellQuantityInput.value) - this.quantityRules.increment;
        }
      }
    } else if (isClick && event.target.name === 'plus') {
      // Click - plus button
      quantityInput.value = parseInt(quantityInput.value) + this.quantityRules.increment;
      if (upsellQuantityInput != null){
        upsellQuantityInput.value = parseInt(upsellQuantityInput.value) + this.quantityRules.increment;
      }
    } else {
      // Change - input field
      // round the input value to closest increment value if not already
      const roundedValue = Math.round(event.target.value / this.quantityRules.increment) * this.quantityRules.increment;
      quantityInput.value = roundedValue;

      // Don't round to zero, unless the user has manually entered zero
      if (parseInt(quantityInput.value) === 0 && parseInt(event.target.value) > 0) {
        quantityInput.value = this.quantityRules.increment;
      }
    }

    // Make sure quantity is not less than 0
    if (parseInt(quantityInput.value) < 0) {
      quantityInput.value = 0;
    }

    // Make sure quantity is not over the max quantity. Null means no max quantity
    if (this.quantityRules.max && parseInt(quantityInput.value) > this.quantityRules.max) {
      quantityInput.value = this.quantityRules.max;
    }

    // Make sure debounce is not called multiple times in a row
    if (this.waitingForPreviousDebounce) {
      return;
    }
    
    // Update the cart, with "debounce" function
    const debouncedUpdate = (func, wait) => {
      let timeout;
      return function executedFunction() {
        const later = () => {
          timeout = null;
          func();
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

    this.waitingForPreviousDebounce = true;
    const debounceDelay = isClick ? 750 : 350;

    // fire "variantItemQuantityChange" event
    debouncedUpdate(() => {
      this.dispatchEvent(new CustomEvent('variantItemQuantityChange', {
        bubbles: true,
        detail: {
          variantId: parseInt(this.dataset.variantId),
          quantity: parseInt(this.querySelector('input[type=number]').value),
        }
      }))
      this.waitingForPreviousDebounce = false;
    }, debounceDelay)();
  }
}
customElements.define('variant-item', VariantItem);

// SEARCH VARIANT ITEMS

class ProductVariantSearch extends HTMLElement {
  constructor() {
    super();

    this.processing = false;
    this.mapboxKey =
      'pk.eyJ1IjoiY2VydHN1cmVzaG9waWZ5IiwiYSI6ImNtNzF5NGdiNzA1NDAyanNpN2NtdnZlcWMifQ.N4H4tIydnWOmEsXtbRJ1Iw';
    this.input = this.querySelector('input[name="q"]');
    this.selector = this.querySelector('select[name="sort"]');
    this.filterBy = this.querySelector('select[name="filter"]');
    this.target = document.getElementById(this.dataset.target);
    this.entries = document.getElementById(this.dataset.entries)?.textContent;
    this.filterPreselected = this.querySelector('input[name="pre-selected"]');

 /*     this.location = navigator?.geolocation?.getCurrentPosition((position) => { 
      return position.coords;
    }, (error) => {
      if (error.code === 2) {
        console.error('POSITION_UNAVAILABLE', error)
      } else if (error.code === 1) {
        console.error('PERMISSION_DENIED', error)
      } else if (error.code === 3) {
        console.error('TIMEOUT', error)
      }
    }); */

    if (!this.input || !this.target) {
      console.error('ProductVariantSearch: Missing input or target');
      return;
    }

    if (!this.dataset && this.dataset === '') {
      console.error('ProductVariantSearch: Missing dataset');
      return;
    }

    this.targets = this.target.querySelectorAll('.variant-row');

    // Parse and add entries to filter dropdown
    const parsedEntries = JSON.parse(this.entries);
    const uniqueVenues = [...new Set(parsedEntries.map((entry) => entry.venue))];
    uniqueVenues.forEach((venue) => {
      const option = document.createElement('option');
      option.value = venue;
      option.textContent = venue;
      this.filterBy.appendChild(option);
    });
  }

  connectedCallback() {
    this.input.addEventListener('input', this.search.bind(this));
    this.selector.addEventListener('change', this.sort.bind(this));
    this.filterBy.addEventListener('change', this.filter.bind(this));


    // Trigger sort by with default value 
    this.selector.dispatchEvent(new Event('change'));

    // Check if filterPreselected has a value and execute filtering
    if (this.filterPreselected && this.filterPreselected.value.trim() !== '') {
      this.filterBy.value = this.filterPreselected.value.trim();
      this.filterBy.dispatchEvent(new Event('change'));
    }

  }

  async filter(evt) {
    if (this.processing) return;

    // Filter entries by location, or show all if "all" is selected
    const query = evt.target.value;
    this.processing = true;

    const entries = JSON.parse(this.entries);
    const results =
      query === 'all'
        ? entries
        : entries.filter((entry) => entry.venue === query);

    this.renderSearchResults(results);
  }

  async sort(evt) {
    if (this.processing) return;

    const sortDir = evt.target.value; // 'asc' or 'desc'
    this.processing = true;

    const entries = JSON.parse(this.entries);
    const sortedEntries = entries.sort((a, b) => {
      return sortDir === 'asc'
        ? new Date(a.date) - new Date(b.date)
        : new Date(b.date) - new Date(a.date);
    });

    this.renderSortedResults(sortedEntries);
  }

  async search(evt) {
    if (this.processing) return;
  
    const query = evt.target.value.toLowerCase();
    this.processing = true;
  
    // 1) If the user hasn't typed enough characters, optionally do nothing
    //    or revert to some default listing, as you'd like:
    if (query.length < 3) {
      this.processing = false;
      return;
    }
  
    // 2) Attempt a geocode request to Mapbox
    const url = new URL('https://api.mapbox.com/search/geocode/v6/forward');
    url.searchParams.append('access_token', this.mapboxKey);
    url.searchParams.append('q', query);
    url.searchParams.append('country', 'GB');
  
    try {
      const response = await fetch(url);
      const data = await response.json();
  
      // 3) If a geocode match is found
      if (data?.features?.length > 0) {
        const { coordinates } = data.features[0].geometry;
        console.log('First geocode match:', data.features[0]);
  
        // Parse original entries
        const entries = JSON.parse(this.entries);
  
        // Helper to compute distance in km between two coordinate pairs
        const computeDistance = (entryCoords, targetCoords) => {
          const [lon1, lat1] = entryCoords;
          const [lon2, lat2] = targetCoords;
  
          const R = 6371; // Earth's radius in km
          const toRad = (val) => (val * Math.PI) / 180;
  
          const dLat = toRad(lat2 - lat1);
          const dLon = toRad(lon2 - lon1);
  
          const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) *
              Math.cos(toRad(lat2)) *
              Math.sin(dLon / 2) *
              Math.sin(dLon / 2);
  
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          return R * c; // distance in kilometers
        };
  
        // 4) Compute a distance for every entry, then sort
        entries.forEach((entry) => {
          const entryCoords = [
            parseFloat(entry.longitude),
            parseFloat(entry.latitude),
          ];
       
          entry.distance = computeDistance(entryCoords, coordinates);
          
        });
  
        // 5) Sort all entries ascending by distance
        entries.sort((a, b) => a.distance - b.distance);
  
        // 6) Unhide all .variant-row items (so we show everything)
        //this.targets.forEach((target) => target.classList.remove('hide'));
  
        // 7) Reorder DOM based on distance
        this.renderSortedResults(entries, coordinates);
  
        this.processing = false;
        return;
      }
  
      // 8) If no geocode features found, do fallback
      console.warn('No geocoding result found for:', query);
      // e.g. show all items unfiltered, or do text-based fallback
      this.targets.forEach((target) => target.classList.remove('hide'));
      this.renderSortedResults(JSON.parse(this.entries));
      this.processing = false;
  
    } catch (err) {
      console.error('Geocoding search failed:', err);
      // Fallback: just show all items unfiltered
      this.targets.forEach((target) => target.classList.remove('hide'));
      this.renderSortedResults(JSON.parse(this.entries));
      this.processing = false;
    }
  }
  

  renderSearchResults(array) {
    // Show/hide variant rows based on provided array
    this.targets.forEach((target) => {
      const variantId = `${target.dataset.variantId}`;
      const found = array.find((entry) => entry.variant_id === variantId);
      found ? target.classList.remove('hide') : target.classList.add('hide');
    });


    // Trigger event with search results
    const event = new CustomEvent('ajaxProduct:searchResults', {
      detail: {
        results: array,
      },
    });
    document.dispatchEvent(event);

    this.processing = false;
  }

  renderSortedResults(array, coordinates = []) {
    // Reorder variant rows based on array order
    const fragment = document.createDocumentFragment();

    array.forEach((entry) => {
      const row = [...this.targets].find(
        (target) => target.dataset.variantId === `${entry.variant_id}`
      );
      if (row) {
        // Use the distance field from `entry`
        const distance = entry.distance || 0;
        if (!distance || distance == 0) {
          fragment.appendChild(row);
          return;
        }
        const distanceInMiles = distance * 0.621371;
        const distanceWithNoDecimals = distanceInMiles.toFixed(0);
  
        // Find the .variant-title element and append the distance text
        const variantTitle = row.querySelector('.variant-venue');

        // Does it have original title stored?
        const originalTitle = row.dataset.originalTitle;

        if (variantTitle && !originalTitle) {
          // Store the original title
          row.dataset.originalTitle = variantTitle.textContent;
        }

        if (variantTitle) {
          if (originalTitle) {
            // Restore the original title
            variantTitle.textContent = originalTitle;
          }
          
          // Append or inject text about the distance
          variantTitle.textContent += ` - ${distanceWithNoDecimals} mi away`;
        }
  
        // Finally, append this row into our fragment
        fragment.appendChild(row);
      }
    });

    // Append them back into the container in new order
    this.target.appendChild(fragment);

    // Trigger event with sorted results
    const event = new CustomEvent('ajaxProduct:searchResults', {
      detail: {
        results: array,
        coordinates
      },
    });
    document.dispatchEvent(event);

    this.processing = false;
  }
}

customElements.define('product-variant-search', ProductVariantSearch);

// Rebuy modal scroll fix - scroll page up when modal opens to avoid footer overlap
(function() {
  // Function to scroll page up when Rebuy modal appears
  function handleRebuyModal() {
    const scrollPosition = window.scrollY;
    
    // Scroll up by 300px to ensure modal is fully visible above footer
    window.scrollTo({
      top: Math.max(0, scrollPosition - 800),
      behavior: 'smooth'
    });
    
    console.log('Rebuy modal detected - scrolling up');
  }

  // Watch for class changes on existing elements and new elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      // Check for attribute changes (class modifications)
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const element = mutation.target;
        const classList = element.className || '';
        
        // Check if element has rebuy-widget-container and is-visible classes
        if (classList.includes('rebuy-widget-container') && classList.includes('is-visible')) {
          setTimeout(handleRebuyModal, 100);
        }
      }
      
      // Check for newly added nodes
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          const className = (node.className || '').toString();
          
          // Check if it's a visible Rebuy widget container
          if (className.includes('rebuy-widget-container') && className.includes('is-visible')) {
            setTimeout(handleRebuyModal, 100);
          }
          
          // Also check children of newly added nodes
          if (node.querySelectorAll) {
            const rebuyWidgets = node.querySelectorAll('.rebuy-widget-container.is-visible');
            if (rebuyWidgets.length > 0) {
              setTimeout(handleRebuyModal, 100);
            }
          }
        }
      });
    });
  });

  // Start observing once DOM is ready
  function startObserving() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    console.log('Rebuy scroll observer initialized');
  }

  if (document.body) {
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }

  // Also listen for Rebuy events if available
  document.addEventListener('rebuy.modal.open', () => {
    console.log('Rebuy modal.open event fired');
    handleRebuyModal();
  });
})();

/*
// Listen for Rebuy product additions and add linking attribute
document.addEventListener('rebuy.add', async function(event) {

  console.log('rebuy.add event', event.detail);
  console.log('Last added variants before Rebuy:', window.lastAddedVariants);

  try {

    // Get the Rebuy product ID that was just added from the event
    const addedRebuyProductId = event.detail?.product?.id || event.detail?.id;
    const addedRebuyVariantId = event.detail?.variant?.id || event.detail?.variant_id;
    
    console.log('Added Rebuy product ID:', addedRebuyProductId);
    console.log('Added Rebuy variant ID:', addedRebuyVariantId);

    // Wait a moment for Rebuy to finish adding the product
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Fetch current cart AFTER Rebuy added the product
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) throw new Error('Failed to fetch cart');
    
    const cart = await cartResponse.json();
    
    // Find all main product variants currently in cart (non-Rebuy items)
    // Only include delegate/training products (those with _delegate_index property)
    const mainProductVariants = cart.items
      .filter(item => {
        if (item.properties && item.properties._source === 'Rebuy') return false;
        // Only include items that have _delegate_index (delegate products)
        return item.properties && item.properties._delegate_index !== undefined;
      })
      .map(item => item.variant_id);
    
    console.log('Main product variants in cart:', mainProductVariants);
    
    // Find Rebuy items that don't have the linking property yet
    const rebuyItemsToUpdate = cart.items.filter(item => 
      item.properties && 
      item.properties._source === 'Rebuy' &&
      !item.properties._linked_to_variants
    );
    
    console.log('Rebuy items to update:', rebuyItemsToUpdate);
    
    // Update each Rebuy item with the linking property
    for (const rebuyItem of rebuyItemsToUpdate) {
      const updateResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: rebuyItem.key,
          properties: {
            ...rebuyItem.properties,
            _linked_to_variants: mainProductVariants.join(',')
          }
        })
      });
      
      if (!updateResponse.ok) {
        console.error('Failed to update Rebuy item:', rebuyItem.key);
      } else {
        console.log('Updated Rebuy item:', rebuyItem.key);
      }
    }
    
    console.log('Finished updating Rebuy items with linking properties');
  } catch (error) {
    console.error('Error in rebuy.add handler:', error);
  }
});*/

// Listen for Rebuy product additions and add linking attribute
document.addEventListener('rebuy.add', async function(event) {
  console.log('rebuy.add event', event.detail);
  console.log('Last added variants before Rebuy:', window.lastAddedVariants);

  try {
    // Get the Rebuy product ID that was just added from the event
    const addedRebuyProductId = event.detail?.product?.id || event.detail?.id;
    const addedRebuyVariantId = event.detail?.variant?.id || event.detail?.variant_id;
    
    console.log('Added Rebuy product ID:', addedRebuyProductId);
    console.log('Added Rebuy variant ID:', addedRebuyVariantId);

    // Wait a moment for Rebuy to finish adding the product
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Fetch current cart AFTER Rebuy added the product
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) throw new Error('Failed to fetch cart');
    
    const cart = await cartResponse.json();
    
    // Use the tracked variants from window.lastAddedVariants
    const mainProductVariants = window.lastAddedVariants && window.lastAddedVariants.length > 0 
      ? window.lastAddedVariants 
      : [];
    
    console.log('Main product variants to link:', mainProductVariants);
    
    if (mainProductVariants.length === 0) {
      console.warn('No tracked variants to link Rebuy product to');
      return;
    }
    
    // Find all Rebuy items without _linked_to_variants property
    const rebuyItemsWithoutLinks = cart.items.filter(item => 
      item.properties && 
      item.properties._source === 'Rebuy' &&
      !item.properties._linked_to_variants
    );
    
    console.log('All Rebuy items without links:', rebuyItemsWithoutLinks);
    
    // Get the most recently added one (should be the last in the array)
    const rebuyItemToUpdate = rebuyItemsWithoutLinks[rebuyItemsWithoutLinks.length - 1];
    
    if (!rebuyItemToUpdate) {
      console.log('No new Rebuy item to update');
      return;
    }
    
    console.log('Rebuy item to update (latest):', rebuyItemToUpdate);
    
    // Update the Rebuy item with the linking property from window.lastAddedVariants
    const updateResponse = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: rebuyItemToUpdate.key,
        properties: {
          ...rebuyItemToUpdate.properties,
          _linked_to_variants: mainProductVariants.join(',')
        }
      })
    });
    
    if (!updateResponse.ok) {
      console.error('Failed to update Rebuy item:', rebuyItemToUpdate.key);
    } else {
      console.log('Successfully linked Rebuy item to variants:', mainProductVariants.join(','));
    }
    
    // Clear the tracking array after linking
    window.lastAddedVariants = [];
    
    console.log('Finished updating Rebuy item with linking properties');
  } catch (error) {
    console.error('Error in rebuy.add handler:', error);
  }
});

